import Box from '@ilg-totallymoney/ui/components/Box'
import Grid from '@ilg-totallymoney/ui/components/Grid'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'

import LandingPageCta from '@components/LandingPageComponents/LandingPageCta'
import LandingPageDetailsSection from '@components/LandingPageComponents/LandingPageDetailsSection'
import LandingPageHead from '@components/LandingPageComponents/LandingPageHead'
import LandingPageHero from '@components/LandingPageComponents/LandingPageHero'
import TrustBox from '@components/TrustBox'

const CreditCardsLandingPage = () => {
    return (
        <>
            <LandingPageHead title="We compare over 90 credit cards with limits of up to £15,000 with TotallyMoney" />

            <Box mb="space20">
                <LandingPageHero />
            </Box>

            <Grid>
                <Box gridColumn={['1/13', '1/13', '2/12', '3/11']} mb="space80">
                    <TrustBox />
                </Box>

                <Stack gridColumn="1/13" space="space80" mb="space80">
                    <LandingPageDetailsSection />

                    <Stack space="space40">
                        <LandingPageCta
                            heading="See if it's a yes before you apply"
                            text="Get a response in 30 seconds, no credit check required"
                            link={{
                                text: 'See my offers',
                            }}
                        />

                        <Text textAlign="center">
                            * Pre-approval is subject to credit and final lender
                            checks. Guaranteed features are what you’ll get, if
                            accepted.
                        </Text>
                    </Stack>
                </Stack>
            </Grid>
        </>
    )
}

export default CreditCardsLandingPage
